import { useCallback, useState } from 'react';
export interface Coordinate {
    Latitude: number;
    Longitude: number;
}
interface IUseCurrentUserCoordinates {
    userCoordinates: Coordinate;
    findUserCoordinates: () => void;
    loaded: boolean;
    loading: boolean;
}
export const useCurrentCoordinates = (
    coordinates: Coordinate = { Latitude: 0, Longitude: 0 },
    skip?: boolean
): IUseCurrentUserCoordinates => {
    const [userCoordinates, setUserCoordinates] =
        useState<Coordinate>(coordinates);

    const [loaded, setLoaded] = useState(false);
    const [loading, setLoading] = useState(false);

    const findUserCoordinates = useCallback(async () => {
        setLoaded(false);
        if (skip) {
            setLoaded(true);
            return;
        }
        setLoading(true);

        let userGeoCoords: Coordinate | null = null;

        // Get the visitor's current position from browser first, this is the most accurate
        try {
            userGeoCoords = await getCoordinatesByBrowser();
        } catch (error) {
            console.log(
                "Get current visitor's coordinates by browser result: ",
                error
            );
        }

        // Todo:  get coordinates from other methods
        // e.g.from user's region, cloudflare region cookies, ip address, etc.

        if (
            userGeoCoords &&
            (userGeoCoords.Latitude !== 0 || userGeoCoords.Longitude !== 0)
        ) {
            setUserCoordinates(userGeoCoords);
        }
        setLoaded(true);
        setLoading(false);
    }, [skip]);

    return { userCoordinates, findUserCoordinates, loaded, loading };
};

export const getCoordinatesByBrowser = async (): Promise<Coordinate | null> => {
    if (navigator?.geolocation) {
        const navGetCurrentPosition: Promise<Coordinate> = new Promise(
            (resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            Latitude: position.coords.latitude,
                            Longitude: position.coords.longitude,
                        });
                    },
                    (error) => reject(error),
                    {
                        enableHighAccuracy: false,
                        timeout: 15000,
                        maximumAge: 1000,
                    }
                );
            }
        );
        const userGeoCoords = await navGetCurrentPosition;

        if (userGeoCoords) {
            return userGeoCoords;
        }
    }
    return null;
};
